import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import styles from './ArtistHeroCard.module.css';
import ResolvedStorageImage from './ResolvedStorageImage';
import { getArtistPhotoPath } from '../utils/storageMedia';

export default function ArtistHeroCard({
  artist = null,
  eyebrow = 'Artist',
  subtitle = 'Verified artist collectible',
  onClick = null,
}) {
  const name = String(artist?.artistFullName || 'Unknown Artist').trim() || 'Unknown Artist';
  const photoPath = getArtistPhotoPath(artist, 'thumb');
  const Component = onClick ? 'button' : 'div';
  return (
    <Component className={`${styles.card} ${onClick ? styles.cardButton : ''}`.trim()} onClick={onClick} type={onClick ? 'button' : undefined}>
      <div className={styles.avatarWrap}>
        <ResolvedStorageImage
          path={photoPath}
          alt={name}
          className={styles.avatar}
          fallback={<div className={styles.placeholder}>Artist</div>}
        />
      </div>
      <div className={styles.copy}>
        <span className={styles.eyebrow}>{eyebrow}</span>
        <div className={styles.titleRow}>
          <strong>{name}</strong>
          {onClick ? <FiArrowUpRight aria-hidden="true" /> : null}
        </div>
        <p>{subtitle}</p>
      </div>
    </Component>
  );
}
